import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

const sections = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'contacts', label: 'Contact Enquiries' },
  { id: 'donations', label: 'Donation Inquiries' },
  { id: 'gallery', label: 'Gallery Management' },
  { id: 'past-events', label: 'Past Activities' },
  { id: 'events', label: 'Upcoming Events' },
  { id: 'press', label: 'Press Releases' },
  { id: 'settings', label: 'Site Settings' },
];

function renderIcon(id) {
  const props = {
    width: 18,
    height: 18,
    strokeWidth: 2.2,
    stroke: 'currentColor',
    fill: 'none',
    style: { marginRight: 12, flexShrink: 0 }
  };
  switch (id) {
    case 'dashboard':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <rect x="3" y="3" width="7" height="9" rx="1" />
          <rect x="14" y="3" width="7" height="5" rx="1" />
          <rect x="14" y="12" width="7" height="9" rx="1" />
          <rect x="3" y="16" width="7" height="5" rx="1" />
        </svg>
      );
    case 'contacts':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
      );
    case 'donations':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <line x1="12" y1="1" x2="12" y2="23" />
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      );
    case 'gallery':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <polyline points="21 15 16 10 5 21" />
        </svg>
      );
    case 'events':
    case 'past-events':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      );
    case 'press':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <path d="M16 8h2M16 12h2M8 8h5M8 12h5M8 16h10" />
        </svg>
      );
    case 'settings':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      );
    case 'website':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
      );
    case 'lock':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      );
    default:
      return null;
  }
}

function Admin() {
  const [authorized, setAuthorized] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);

  const [section, setSection] = useState('dashboard');
  const [stats, setStats] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [donations, setDonations] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [events, setEvents] = useState([]);
  const [press, setPress] = useState([]);
  const [settings, setSettings] = useState({
    phone: '',
    email: '',
    address: '',
    whatsapp: '',
    hours: '',
    googleMapsUrl: '',
    facebookUrl: '',
    instagramUrl: '',
    youtubeUrl: '',
    bankName: '',
    bankAccountName: '',
    bankAccountNumber: '',
    bankIban: '',
    bankSwift: '',
    donationMessage: '',
  });

  // Change-password form state
  const [pwForm, setPwForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [pwMessage, setPwMessage] = useState('');

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  // Editing States
  const [editingId, setEditingId] = useState(null);

  // Forms
  const [galleryForm, setGalleryForm] = useState({ title: '', category: 'Facility', emoji: '📸', imageUrl: '' });
  const [eventForm, setEventForm] = useState({ title: '', description: '', date: '', location: '', emoji: '📅', imageUrl: '', type: 'future' });
  const [pressForm, setPressForm] = useState({ title: '', summary: '', content: '', date: '', emoji: '📰', imageUrl: '' });

  // On mount: verify stored token via the backend
  useEffect(() => {
    const token = localStorage.getItem('megaAdminToken');
    if (!token) {
      setLoading(false);
      return;
    }
    api.post('/login?action=verify', { token })
      .then(res => {
        if (res.data.valid) {
          setAuthorized(true);
          loadAll();
        } else {
          localStorage.removeItem('megaAdminToken');
          setLoading(false);
        }
      })
      .catch(() => {
        localStorage.removeItem('megaAdminToken');
        setLoading(false);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUnlock = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    setLoginError('');
    try {
      const res = await api.post('/login', { username, password });
      localStorage.setItem('megaAdminToken', res.data.token);
      setAuthorized(true);
      setUsername('');
      setPassword('');
      loadAll();
    } catch (err) {
      const msg = err.response?.data?.message || 'Login failed. Check your credentials.';
      setLoginError(msg);
    } finally {
      setLoginLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('megaAdminToken');
    setAuthorized(false);
    setUsername('');
    setPassword('');
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setPwMessage('');
    if (pwForm.newPassword !== pwForm.confirmPassword) {
      setPwMessage('New passwords do not match.');
      return;
    }
    if (pwForm.newPassword.length < 8) {
      setPwMessage('New password must be at least 8 characters.');
      return;
    }
    try {
      const token = localStorage.getItem('megaAdminToken');
      const res = await api.post('/login?action=change-password', {
        token,
        currentPassword: pwForm.currentPassword,
        newPassword: pwForm.newPassword,
      });
      // Store the refreshed token
      localStorage.setItem('megaAdminToken', res.data.token);
      setPwForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setPwMessage('✓ Password changed successfully!');
    } catch (err) {
      setPwMessage(err.response?.data?.message || 'Failed to change password.');
    }
  };

  async function loadAll() {
    setLoading(true);
    try {
      const [statsRes, contactsRes, donationsRes, galleryRes, eventsRes, pressRes, settingsRes] = await Promise.all([
        api.get('/admin'),
        api.get('/contact'),
        api.get('/donation'),
        api.get('/gallery/all'),
        api.get('/events/all'),
        api.get('/press/all'),
        api.get('/settings'),
      ]);
      setStats(statsRes.data);
      setContacts(Array.isArray(contactsRes.data) ? contactsRes.data : []);
      setDonations(Array.isArray(donationsRes.data) ? donationsRes.data : []);
      setGallery(Array.isArray(galleryRes.data) ? galleryRes.data : []);
      setEvents(Array.isArray(eventsRes.data) ? eventsRes.data : []);
      setPress(Array.isArray(pressRes.data) ? pressRes.data : []);
      if (settingsRes.data) {
        setSettings(settingsRes.data);
      }
    } catch (err) {
      console.error(err);
      setMessage('Unable to load administration records. Ensure the PHP backend is active.');
    } finally {
      setLoading(false);
    }
  }

  // File to Base64 Reader Utility
  const handleImageUpload = (e, setFormCallback) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormCallback(f => ({ ...f, imageUrl: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  // CRUD Submissions
  async function handleGallerySubmit(e) {
    e.preventDefault();
    try {
      if (editingId) {
        await api.put(`/gallery/${editingId}`, galleryForm);
        setMessage('Gallery item updated.');
      } else {
        await api.post('/gallery', galleryForm);
        setMessage('Gallery item created successfully.');
      }
      setGalleryForm({ title: '', category: 'Facility', emoji: '📸', imageUrl: '' });
      setEditingId(null);
      loadAll();
    } catch {
      setMessage('Failed to save gallery item.');
    }
  }

  async function handleEventSubmit(e) {
    e.preventDefault();
    try {
      // Force the type based on the active section to ensure correctness
      const payload = { ...eventForm, type: section === 'past-events' ? 'past' : 'future' };
      if (editingId) {
        await api.put(`/events/${editingId}`, payload);
        setMessage('Event item updated.');
      } else {
        await api.post('/events', payload);
        setMessage('Event item created successfully.');
      }
      setEventForm({ title: '', description: '', date: '', location: '', emoji: '📅', imageUrl: '', type: section === 'past-events' ? 'past' : 'future' });
      setEditingId(null);
      loadAll();
    } catch {
      setMessage('Failed to save event.');
    }
  }

  async function handlePressSubmit(e) {
    e.preventDefault();
    try {
      if (editingId) {
        await api.put(`/press/${editingId}`, pressForm);
        setMessage('Press release updated.');
      } else {
        await api.post('/press', pressForm);
        setMessage('Press release created successfully.');
      }
      setPressForm({ title: '', summary: '', content: '', date: '', emoji: '📰', imageUrl: '' });
      setEditingId(null);
      loadAll();
    } catch {
      setMessage('Failed to save press release.');
    }
  }

  async function handleSettingsSubmit(e) {
    e.preventDefault();
    try {
      await api.put('/settings', settings);
      setMessage('Site settings updated successfully.');
      loadAll();
    } catch {
      setMessage('Failed to save site settings.');
    }
  }

  // Delete Action
  async function deleteItem(type, id) {
    if (!window.confirm('Are you sure you want to delete this record?')) return;
    try {
      await api.delete(`/${type}/${id}`);
      setMessage('Record deleted.');
      loadAll();
    } catch {
      setMessage('Failed to delete item.');
    }
  }

  // Toggle statuses
  async function toggleContactStatus(id, currentStatus) {
    const nextStatus = currentStatus === 'new' ? 'read' : 'new';
    try {
      await api.patch(`/contact/${id}/status`, { status: nextStatus });
      setMessage('Contact status updated.');
      loadAll();
    } catch {
      setMessage('Failed to update status.');
    }
  }

  async function toggleDonationStatus(id, currentStatus) {
    const nextStatus = currentStatus === 'new' ? 'read' : 'new';
    try {
      await api.patch(`/donation/${id}/status`, { status: nextStatus });
      setMessage('Donation status updated.');
      loadAll();
    } catch {
      setMessage('Failed to update status.');
    }
  }

  // Edit Initiations
  const startEditGallery = (item) => {
    setEditingId(item.id || item._id);
    setGalleryForm({ title: item.title, category: item.category, emoji: item.emoji || '📸', imageUrl: item.imageUrl || '' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const startEditEvent = (item) => {
    setEditingId(item.id || item._id);
    setEventForm({ title: item.title, description: item.description, date: item.date, location: item.location || '', emoji: item.emoji || '📅', imageUrl: item.imageUrl || '', type: item.type || 'future' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const startEditPress = (item) => {
    setEditingId(item.id || item._id);
    setPressForm({ title: item.title, summary: item.summary, content: item.content || '', date: item.date, emoji: item.emoji || '📰', imageUrl: item.imageUrl || '' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setGalleryForm({ title: '', category: 'Facility', emoji: '📸', imageUrl: '' });
    setEventForm({ title: '', description: '', date: '', location: '', emoji: '📅', imageUrl: '', type: section === 'past-events' ? 'past' : 'future' });
    setPressForm({ title: '', summary: '', content: '', date: '', emoji: '📰', imageUrl: '' });
  };

  // Locked Login Screen
  if (!authorized) {
    return (
      <div className="lock-screen-wrapper">
        <div className="lock-card">
          <div className="lock-icon" style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
            <svg viewBox="0 0 24 24" width="54" height="54" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--gold-primary)' }}>
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              <circle cx="12" cy="16" r="1.5" fill="currentColor" />
              <line x1="12" y1="17.5" x2="12" y2="19" stroke="currentColor" strokeWidth="2" />
            </svg>
          </div>
          <h2 style={{ color: 'var(--teal-dark)' }}>Admin Console</h2>
          <p style={{ fontSize: '0.88rem', margin: '8px 0 24px' }}>Mega Health Group Management Dashboard</p>
          <form onSubmit={handleUnlock}>
            <div className="form-group" style={{ textAlign: 'left' }}>
              <label>Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username..."
                required
                autoComplete="username"
              />
            </div>
            <div className="form-group" style={{ textAlign: 'left' }}>
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password..."
                required
                autoComplete="current-password"
                style={{ letterSpacing: '0.15em' }}
              />
            </div>
            {loginError && <p style={{ color: 'var(--danger)', fontSize: '0.88rem', margin: '0 0 16px', fontWeight: 600 }}>{loginError}</p>}
            <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loginLoading}>
              {loginLoading ? 'Verifying...' : 'Unlock Dashboard'}
            </button>
            <div style={{ marginTop: 20 }}>
              <Link to="/" style={{ fontSize: '0.88rem', color: 'var(--teal-primary)', fontWeight: 600 }}>← Return to Homepage</Link>
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-layout">
      {/* Sidebar navigation */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <div className="brand">Mega Health Group</div>
          <div className="sub">Admin Dashboard</div>
        </div>
        <nav className="admin-nav">
          {sections.map(item => (
            <button
              key={item.id}
              type="button"
              className={`admin-nav-link ${section === item.id ? 'active' : ''}`}
              onClick={() => {
                setSection(item.id);
                cancelEdit();
                if (item.id === 'events') setEventForm(f => ({...f, type: 'future'}));
                if (item.id === 'past-events') setEventForm(f => ({...f, type: 'past'}));
                setMessage('');
              }}
            >
              {renderIcon(item.id)}
              <span>{item.label}</span>
            </button>
          ))}
        </nav>
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: 16, display: 'grid', gap: 10 }}>
          <Link to="/" className="admin-nav-link" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.06)' }}>
            {renderIcon('website')}
            <span>View Website</span>
          </Link>
          <button onClick={handleLogout} className="admin-nav-link" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--danger)', color: 'white' }}>
            {renderIcon('lock')}
            <span>Lock Console</span>
          </button>
        </div>
      </aside>

      {/* Main Panel Content */}
      <main className="admin-main">
        <div className="admin-topbar">
          <h1 style={{ color: 'var(--teal-dark)' }}>{sections.find(s => s.id === section)?.label}</h1>
        </div>

        {message && (
          <div className="admin-message">
            <span>{message}</span>
            <span className="close" onClick={() => setMessage('')}>✕</span>
          </div>
        )}
        
        {loading && <p style={{ fontSize: '1.1rem', color: 'var(--muted)' }}>Retrieving data records...</p>}

        {/* Dashboard Modules */}
        {!loading && section === 'dashboard' && stats && (
          <div>
            <div className="admin-stats-grid">
              <div className="card"><h3>{stats.counts.contacts}</h3><p>Contact Enquiries</p></div>
              <div className="card"><h3>{stats.counts.donations}</h3><p>Donation Inquiries</p></div>
              <div className="card"><h3>{stats.counts.gallery}</h3><p>Gallery Items</p></div>
              <div className="card"><h3>{stats.counts.events}</h3><p>Health Events</p></div>
              <div className="card"><h3>{stats.counts.press}</h3><p>Press Releases</p></div>
              <div className="card" style={{ background: 'var(--teal-soft)' }}>
                <h3 style={{ color: 'var(--teal-primary)' }}>{stats.counts.newContacts + stats.counts.newDonations}</h3>
                <p style={{ color: 'var(--teal-primary)' }}>New Submissions</p>
              </div>
            </div>

            <div className="grid-2">
              <div className="card" style={{ padding: 24 }}>
                <h3 style={{ fontSize: '1.25rem', marginBottom: 16 }}>Recent Enquiries</h3>
                {contacts.length === 0 ? (
                  <p style={{ fontSize: '0.88rem' }}>No enquiries submitted yet.</p>
                ) : (
                  <div style={{ display: 'grid', gap: 12 }}>
                    {contacts.slice(0, 5).map(c => (
                      <div key={c.id || c._id} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid var(--border)', paddingBottom: 8, fontSize: '0.88rem' }}>
                        <div>
                          <strong>{c.firstName} {c.lastName}</strong> ({c.service})
                        </div>
                        <span style={{ background: c.status === 'new' ? 'var(--gold-light)' : 'var(--teal-soft)', padding: '2px 8px', borderRadius: 4, fontSize: '0.72rem', fontWeight: 700 }}>
                          {c.status}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="card" style={{ padding: 24 }}>
                <h3 style={{ fontSize: '1.25rem', marginBottom: 16 }}>Recent Donations</h3>
                {donations.length === 0 ? (
                  <p style={{ fontSize: '0.88rem' }}>No donation inquiries submitted yet.</p>
                ) : (
                  <div style={{ display: 'grid', gap: 12 }}>
                    {donations.slice(0, 5).map(d => (
                      <div key={d.id || d._id} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid var(--border)', paddingBottom: 8, fontSize: '0.88rem' }}>
                        <div>
                          <strong>{d.name}</strong> ({d.amount || 'Custom'})
                        </div>
                        <span style={{ background: d.status === 'new' ? 'var(--gold-light)' : 'var(--teal-soft)', padding: '2px 8px', borderRadius: 4, fontSize: '0.72rem', fontWeight: 700 }}>
                          {d.status}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Contacts enquiries tracking */}
        {!loading && section === 'contacts' && (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Service Requested</th>
                  <th>Date Requested</th>
                  <th>Preferred Slot</th>
                  <th>Status</th>
                  <th style={{ width: 180 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {contacts.length === 0 ? (
                  <tr><td colSpan="7" style={{ textAlign: 'center', color: 'var(--muted)' }}>No enquiries found.</td></tr>
                ) : (
                  contacts.map(item => (
                    <tr key={item.id || item._id} style={{ opacity: item.status === 'read' ? 0.75 : 1 }}>
                      <td style={{ fontWeight: 600 }}>{item.firstName} {item.lastName}</td>
                      <td>{item.phone}</td>
                      <td>{item.service}</td>
                      <td>{item.preferredDate || '—'}</td>
                      <td>{item.preferredTime}</td>
                      <td>
                        <span style={{ background: item.status === 'new' ? 'var(--gold-light)' : 'var(--border)', padding: '4px 10px', borderRadius: 50, fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase' }}>
                          {item.status}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 8 }}>
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            style={{ padding: '6px 12px' }}
                            onClick={() => toggleContactStatus(item.id || item._id, item.status)}
                          >
                            {item.status === 'new' ? 'Read' : 'New'}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            style={{ padding: '6px 12px', borderColor: 'var(--danger)', color: 'var(--danger)' }}
                            onClick={() => deleteItem('contact', item.id || item._id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Donation enquiries tracking */}
        {!loading && section === 'donations' && (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Contact Info</th>
                  <th>Amount</th>
                  <th>Payment Type</th>
                  <th>Submission Date</th>
                  <th>Status</th>
                  <th style={{ width: 180 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {donations.length === 0 ? (
                  <tr><td colSpan="7" style={{ textAlign: 'center', color: 'var(--muted)' }}>No donation inquiries found.</td></tr>
                ) : (
                  donations.map(item => (
                    <tr key={item.id || item._id} style={{ opacity: item.status === 'read' ? 0.75 : 1 }}>
                      <td style={{ fontWeight: 600 }}>{item.name}</td>
                      <td>{item.email || '—'}<br/>{item.phone || '—'}</td>
                      <td style={{ fontWeight: 700, color: 'var(--gold-primary)' }}>{item.amount || 'Custom'}</td>
                      <td>{item.donationType}</td>
                      <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                      <td>
                        <span style={{ background: item.status === 'new' ? 'var(--gold-light)' : 'var(--border)', padding: '4px 10px', borderRadius: 50, fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase' }}>
                          {item.status}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 8 }}>
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            style={{ padding: '6px 12px' }}
                            onClick={() => toggleDonationStatus(item.id || item._id, item.status)}
                          >
                            {item.status === 'new' ? 'Read' : 'New'}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            style={{ padding: '6px 12px', borderColor: 'var(--danger)', color: 'var(--danger)' }}
                            onClick={() => deleteItem('donation', item.id || item._id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Gallery items management */}
        {!loading && section === 'gallery' && (
          <div style={{ display: 'grid', gap: 40 }}>
            <form className="card admin-form" onSubmit={handleGallerySubmit}>
              <h3>{editingId ? 'Edit Gallery Item' : 'Add New Gallery Item'}</h3>
              
              <div className="form-group">
                <label>Item Title</label>
                <input
                  value={galleryForm.title}
                  onChange={e => setGalleryForm(f => ({ ...f, title: e.target.value }))}
                  placeholder="e.g. Pediatric Ward, Blood Camp..."
                  required
                />
              </div>
              
              <div className="form-group">
                <label>Category Tag</label>
                <select
                  value={galleryForm.category}
                  onChange={e => setGalleryForm(f => ({ ...f, category: e.target.value }))}
                >
                  <option value="Facility">Facility & Equipment</option>
                  <option value="Services">Medical Services</option>
                  <option value="Events">Charity Events</option>
                  <option value="General">General</option>
                </select>
              </div>

              <div className="form-group">
                <label>Fallback Emoji (icon)</label>
                <input
                  value={galleryForm.emoji}
                  onChange={e => setGalleryForm(f => ({ ...f, emoji: e.target.value }))}
                  placeholder="e.g. 🏥, 👁, 🤱"
                  required
                />
              </div>

              <div className="form-group">
                <label>Image URL <span style={{ fontWeight: 400, color: 'var(--muted)' }}>(paste a URL, or upload a file below)</span></label>
                <input
                  type="url"
                  value={galleryForm.imageUrl && !galleryForm.imageUrl.startsWith('data:') ? galleryForm.imageUrl : ''}
                  onChange={e => setGalleryForm(f => ({ ...f, imageUrl: e.target.value }))}
                  placeholder="https://example.com/image.jpg"
                />
              </div>

              <div className="form-group">
                <label>— or Upload Photo File —</label>
                <div className="file-upload-wrapper">
                  <input
                    type="file"
                    id="gallery-file"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, setGalleryForm)}
                    style={{ display: 'none' }}
                  />
                  <label htmlFor="gallery-file" className="file-upload-btn">
                    Choose Image File
                  </label>
                  <div className="preview-thumb">
                    {galleryForm.imageUrl ? (
                      <img src={galleryForm.imageUrl} alt="preview" />
                    ) : (
                      <span>{galleryForm.emoji}</span>
                    )}
                  </div>
                </div>
                <p style={{ fontSize: '0.75rem', color: 'var(--muted)', marginTop: 6 }}>
                  <strong>Tip:</strong> Prefer using an image URL (from cPanel File Manager → upload to /images/ folder). File uploads are stored as Base64 which may be slow for large images.
                </p>
              </div>

              <div style={{ display: 'flex', gap: 12 }}>
                <button type="submit" className="btn btn-primary">{editingId ? 'Update Item' : 'Add Item'}</button>
                {editingId && <button type="button" onClick={cancelEdit} className="btn btn-secondary">Cancel</button>}
              </div>
            </form>

            <div>
              <h3 style={{ fontSize: '1.4rem', marginBottom: 20 }}>Existing Photos ({gallery.length})</h3>
              <div className="gallery-masonry">
                {gallery.map(item => (
                  <div key={item.id || item._id} className="gallery-card">
                    <div className="gallery-thumb">
                      {item.imageUrl ? (
                        <img src={item.imageUrl} alt={item.title} />
                      ) : (
                        <span style={{ fontSize: '3rem' }}>{item.emoji}</span>
                      )}
                    </div>
                    <div className="gallery-card-body" style={{ padding: 18 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                        <div className="date">{item.category}</div>
                        <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '2px 7px', borderRadius: 20, background: item.published ? 'var(--teal-soft)' : 'var(--gold-light)', color: item.published ? 'var(--teal-primary)' : 'var(--gold-primary)' }}>
                          {item.published ? 'Published' : 'Hidden'}
                        </span>
                      </div>
                      <h4 style={{ fontSize: '1.05rem', margin: '4px 0 12px' }}>{item.title}</h4>
                      <div style={{ display: 'flex', gap: 8, marginTop: 'auto' }}>
                        <button type="button" className="btn btn-secondary btn-sm" style={{ padding: '6px 12px', flexGrow: 1 }} onClick={() => startEditGallery(item)}>Edit</button>
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm"
                          style={{ padding: '6px 12px', flexGrow: 1, borderColor: item.published ? 'var(--muted)' : 'var(--teal-primary)', color: item.published ? 'var(--muted)' : 'var(--teal-primary)' }}
                          onClick={() => api.put(`/gallery/${item.id || item._id}`, { ...item, published: item.published ? 0 : 1 }).then(loadAll)}
                        >{item.published ? 'Unpublish' : 'Publish'}</button>
                        <button type="button" className="btn btn-secondary btn-sm" style={{ padding: '6px 12px', flexGrow: 1, borderColor: 'var(--danger)', color: 'var(--danger)' }} onClick={() => deleteItem('gallery', item.id || item._id)}>Delete</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Upcoming and Past events management */}
        {!loading && (section === 'events' || section === 'past-events') && (
          <div style={{ display: 'grid', gap: 40 }}>
            <form className="card admin-form" onSubmit={handleEventSubmit}>
              <h3>{editingId ? `Edit ${section === 'past-events' ? 'Past' : 'Upcoming'} Event` : `Add ${section === 'past-events' ? 'Past' : 'Upcoming'} Event`}</h3>
              
              <div className="form-group">
                <label>Event / Activity Title</label>
                <input
                  value={eventForm.title}
                  onChange={e => setEventForm(f => ({ ...f, title: e.target.value }))}
                  placeholder="e.g. Free Eye Screening Camp..."
                  required
                />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  value={eventForm.description}
                  onChange={e => setEventForm(f => ({ ...f, description: e.target.value }))}
                  placeholder="Event details, target audience, schedules..."
                  required
                />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                <div className="form-group">
                  <label>Event Date</label>
                  <input
                    type="date"
                    value={eventForm.date}
                    onChange={e => setEventForm(f => ({ ...f, date: e.target.value }))}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Location</label>
                  <input
                    value={eventForm.location}
                    onChange={e => setEventForm(f => ({ ...f, location: e.target.value }))}
                    placeholder="e.g. Clinic Hall, Outdoor Camp"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Fallback Emoji</label>
                <input
                  value={eventForm.emoji}
                  onChange={e => setEventForm(f => ({ ...f, emoji: e.target.value }))}
                  placeholder="e.g. 📅, 🩺, 🩸, 🤱"
                  required
                />
              </div>

              <div className="form-group">
                <label>Banner Image URL <span style={{ fontWeight: 400, color: 'var(--muted)' }}>(paste URL or upload file below)</span></label>
                <input
                  type="url"
                  value={eventForm.imageUrl && !eventForm.imageUrl.startsWith('data:') ? eventForm.imageUrl : ''}
                  onChange={e => setEventForm(f => ({ ...f, imageUrl: e.target.value }))}
                  placeholder="https://example.com/banner.jpg"
                />
              </div>

              <div className="form-group">
                <label>— or Upload Banner File —</label>
                <div className="file-upload-wrapper">
                  <input
                    type="file"
                    id="event-file"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, setEventForm)}
                    style={{ display: 'none' }}
                  />
                  <label htmlFor="event-file" className="file-upload-btn">
                    Choose Image File
                  </label>
                  <div className="preview-thumb">
                    {eventForm.imageUrl ? (
                      <img src={eventForm.imageUrl} alt="preview" />
                    ) : (
                      <span>{eventForm.emoji}</span>
                    )}
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 12 }}>
                <button type="submit" className="btn btn-primary">{editingId ? 'Update Event' : 'Add Event'}</button>
                {editingId && <button type="button" onClick={cancelEdit} className="btn btn-secondary">Cancel</button>}
              </div>
            </form>

            <div>
              <h3 style={{ fontSize: '1.4rem', marginBottom: 20 }}>Existing Events ({events.filter(e => e.type === (section === 'past-events' ? 'past' : 'future')).length})</h3>
              <div style={{ display: 'grid', gap: 20 }}>
                {events.filter(e => e.type === (section === 'past-events' ? 'past' : 'future')).map(item => (
                  <div key={item.id || item._id} className="card" style={{ display: 'flex', gap: 24, padding: 24, flexWrap: 'wrap', alignItems: 'center' }}>
                    <div className="preview-thumb" style={{ width: 80, height: 80, fontSize: '2.5rem', flexShrink: 0 }}>
                      {item.imageUrl ? (
                        <img src={item.imageUrl} alt={item.title} />
                      ) : (
                        <span>{item.emoji}</span>
                      )}
                    </div>
                    <div style={{ flexGrow: 1, minWidth: 260 }}>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                        <h4 style={{ fontSize: '1.15rem', margin: 0 }}>{item.title}</h4>
                        <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '2px 7px', borderRadius: 20, background: item.published ? 'var(--teal-soft)' : 'var(--gold-light)', color: item.published ? 'var(--teal-primary)' : 'var(--gold-primary)' }}>
                          {item.published ? 'Published' : 'Hidden'}
                        </span>
                      </div>
                      <p style={{ fontSize: '0.88rem', margin: '4px 0' }}>{item.description}</p>
                      <span style={{ fontSize: '0.8rem', color: 'var(--gold-primary)', fontWeight: 700 }}>
                        📅 {item.date} | 📍 {item.location}
                      </span>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button type="button" className="btn btn-secondary btn-sm" onClick={() => startEditEvent(item)}>Edit</button>
                      <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        style={{ borderColor: item.published ? 'var(--muted)' : 'var(--teal-primary)', color: item.published ? 'var(--muted)' : 'var(--teal-primary)' }}
                        onClick={() => api.put(`/events/${item.id || item._id}`, { ...item, published: item.published ? 0 : 1 }).then(loadAll)}
                      >
                        {item.published ? 'Unpublish' : 'Publish'}
                      </button>
                      <button type="button" className="btn btn-secondary btn-sm" style={{ borderColor: 'var(--danger)', color: 'var(--danger)' }} onClick={() => deleteItem('events', item.id || item._id)}>Delete</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Press Releases management */}
        {!loading && section === 'press' && (
          <div style={{ display: 'grid', gap: 40 }}>
            <form className="card admin-form" onSubmit={handlePressSubmit}>
              <h3>{editingId ? 'Edit Press Release' : 'Add Press Release'}</h3>
              
              <div className="form-group">
                <label>Release Title</label>
                <input
                  value={pressForm.title}
                  onChange={e => setPressForm(f => ({ ...f, title: e.target.value }))}
                  placeholder="e.g. ISO Laboratory Certification Achieved..."
                  required
                />
              </div>

              <div className="form-group">
                <label>Summary (Preview Snippet)</label>
                <textarea
                  value={pressForm.summary}
                  onChange={e => setPressForm(f => ({ ...f, summary: e.target.value }))}
                  placeholder="Provide a brief 1-2 sentence preview..."
                  required
                />
              </div>

              <div className="form-group">
                <label>Full Content Body</label>
                <textarea
                  value={pressForm.content}
                  onChange={e => setPressForm(f => ({ ...f, content: e.target.value }))}
                  placeholder="Complete press release body..."
                  style={{ minHeight: 180 }}
                />
              </div>

              <div className="form-group">
                <label>Release Date</label>
                <input
                  type="date"
                  value={pressForm.date}
                  onChange={e => setPressForm(f => ({ ...f, date: e.target.value }))}
                  required
                />
              </div>

              <div className="form-group">
                <label>Fallback Emoji</label>
                <input
                  value={pressForm.emoji}
                  onChange={e => setPressForm(f => ({ ...f, emoji: e.target.value }))}
                  placeholder="e.g. 📰, 🏆, 🔬"
                  required
                />
              </div>

              <div className="form-group">
                <label>Featured Image URL <span style={{ fontWeight: 400, color: 'var(--muted)' }}>(paste URL or upload file below)</span></label>
                <input
                  type="url"
                  value={pressForm.imageUrl && !pressForm.imageUrl.startsWith('data:') ? pressForm.imageUrl : ''}
                  onChange={e => setPressForm(f => ({ ...f, imageUrl: e.target.value }))}
                  placeholder="https://example.com/press.jpg"
                />
              </div>

              <div className="form-group">
                <label>— or Upload Image File —</label>
                <div className="file-upload-wrapper">
                  <input
                    type="file"
                    id="press-file"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, setPressForm)}
                    style={{ display: 'none' }}
                  />
                  <label htmlFor="press-file" className="file-upload-btn">
                    Choose Image File
                  </label>
                  <div className="preview-thumb">
                    {pressForm.imageUrl ? (
                      <img src={pressForm.imageUrl} alt="preview" />
                    ) : (
                      <span>{pressForm.emoji}</span>
                    )}
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 12 }}>
                <button type="submit" className="btn btn-primary">{editingId ? 'Update Release' : 'Add Release'}</button>
                {editingId && <button type="button" onClick={cancelEdit} className="btn btn-secondary">Cancel</button>}
              </div>
            </form>

            <div>
              <h3 style={{ fontSize: '1.4rem', marginBottom: 20 }}>Existing Releases ({press.length})</h3>
              <div style={{ display: 'grid', gap: 20 }}>
                {press.map(item => (
                  <div key={item.id || item._id} className="card" style={{ display: 'flex', gap: 24, padding: 24, flexWrap: 'wrap', alignItems: 'center' }}>
                    <div className="preview-thumb" style={{ width: 80, height: 80, fontSize: '2.5rem', flexShrink: 0 }}>
                      {item.imageUrl ? (
                        <img src={item.imageUrl} alt={item.title} />
                      ) : (
                        <span>{item.emoji}</span>
                      )}
                    </div>
                    <div style={{ flexGrow: 1, minWidth: 260 }}>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                        <h4 style={{ fontSize: '1.15rem', margin: 0 }}>{item.title}</h4>
                        <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '2px 7px', borderRadius: 20, background: item.published ? 'var(--teal-soft)' : 'var(--gold-light)', color: item.published ? 'var(--teal-primary)' : 'var(--gold-primary)' }}>
                          {item.published ? 'Published' : 'Hidden'}
                        </span>
                      </div>
                      <p style={{ fontSize: '0.88rem', margin: '4px 0' }}>{item.summary}</p>
                      <span style={{ fontSize: '0.8rem', color: 'var(--gold-primary)', fontWeight: 700 }}>
                        📅 {item.date}
                      </span>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button type="button" className="btn btn-secondary btn-sm" onClick={() => startEditPress(item)}>Edit</button>
                      <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        style={{ borderColor: item.published ? 'var(--muted)' : 'var(--teal-primary)', color: item.published ? 'var(--muted)' : 'var(--teal-primary)' }}
                        onClick={() => api.put(`/press/${item.id || item._id}`, { ...item, published: item.published ? 0 : 1 }).then(loadAll)}
                      >
                        {item.published ? 'Unpublish' : 'Publish'}
                      </button>
                      <button type="button" className="btn btn-secondary btn-sm" style={{ borderColor: 'var(--danger)', color: 'var(--danger)' }} onClick={() => deleteItem('press', item.id || item._id)}>Delete</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Site settings management */}
        {!loading && section === 'settings' && (
          <>
            <form className="card admin-form" onSubmit={handleSettingsSubmit} style={{ maxWidth: 850 }}>
              <h3>Manage Site Settings</h3>
              <p style={{ fontSize: '0.85rem', marginBottom: 24 }}>Changes here update across layout elements, footer details, maps frames, and banking info panels instantaneously.</p>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
              <div className="form-group">
                <label>Hotline Telephone</label>
                <input
                  value={settings.phone}
                  onChange={e => setSettings(s => ({ ...s, phone: e.target.value }))}
                  placeholder="e.g. +92 123 456 7890"
                  required
                />
              </div>
              <div className="form-group">
                <label>Contact Email</label>
                <input
                  type="email"
                  value={settings.email}
                  onChange={e => setSettings(s => ({ ...s, email: e.target.value }))}
                  placeholder="e.g. info@megahealth.com"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Clinic Address</label>
              <input
                value={settings.address}
                onChange={e => setSettings(s => ({ ...s, address: e.target.value }))}
                placeholder="e.g. 123 Health Street, Amethi, Uttar Pradesh"
                required
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
              <div className="form-group">
                <label>WhatsApp Chat URL</label>
                <input
                  value={settings.whatsapp}
                  onChange={e => setSettings(s => ({ ...s, whatsapp: e.target.value }))}
                  placeholder="e.g. https://wa.me/921234567890"
                  required
                />
              </div>
              <div className="form-group">
                <label>Business Operating Hours</label>
                <input
                  value={settings.hours}
                  onChange={e => setSettings(s => ({ ...s, hours: e.target.value }))}
                  placeholder="e.g. Mon–Sat: 8:00 AM – 8:00 PM"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Google Maps Embed URL</label>
              <textarea
                value={settings.googleMapsUrl}
                onChange={e => setSettings(s => ({ ...s, googleMapsUrl: e.target.value }))}
                placeholder="Paste Google Maps <iframe> src URL here..."
                style={{ minHeight: 70 }}
                required
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginTop: 12 }}>
              <div className="form-group">
                <label>Facebook Profile Link</label>
                <input
                  value={settings.facebookUrl}
                  onChange={e => setSettings(s => ({ ...s, facebookUrl: e.target.value }))}
                  placeholder="e.g. https://facebook.com/..."
                />
              </div>
              <div className="form-group">
                <label>Instagram Handle Link</label>
                <input
                  value={settings.instagramUrl}
                  onChange={e => setSettings(s => ({ ...s, instagramUrl: e.target.value }))}
                  placeholder="e.g. https://instagram.com/..."
                />
              </div>
              <div className="form-group">
                <label>YouTube Channel Link</label>
                <input
                  value={settings.youtubeUrl}
                  onChange={e => setSettings(s => ({ ...s, youtubeUrl: e.target.value }))}
                  placeholder="e.g. https://youtube.com/..."
                />
              </div>
            </div>

            <h4 style={{ color: 'var(--teal-dark)', fontSize: '1.1rem', margin: '24px 0 12px', borderBottom: '1px solid var(--border)', paddingBottom: 6 }}>
              Charity & Bank Donation Settings
            </h4>

            <div className="form-group">
              <label>Donation Page Intro Message</label>
              <textarea
                value={settings.donationMessage}
                onChange={e => setSettings(s => ({ ...s, donationMessage: e.target.value }))}
                placeholder="Introduce charity camp fundraising objectives..."
                style={{ minHeight: 75 }}
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
              <div className="form-group">
                <label>Bank Name</label>
                <input
                  value={settings.bankName}
                  onChange={e => setSettings(s => ({ ...s, bankName: e.target.value }))}
                  placeholder="e.g. Habib Bank Limited"
                  required
                />
              </div>
              <div className="form-group">
                <label>Beneficiary Account Name</label>
                <input
                  value={settings.bankAccountName}
                  onChange={e => setSettings(s => ({ ...s, bankAccountName: e.target.value }))}
                  placeholder="e.g. Mega Health Group Trust"
                  required
                />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
              <div className="form-group">
                <label>Account Number</label>
                <input
                  value={settings.bankAccountNumber}
                  onChange={e => setSettings(s => ({ ...s, bankAccountNumber: e.target.value }))}
                  placeholder="e.g. 0123-456789-01"
                  required
                />
              </div>
              <div className="form-group">
                <label>IBAN Code</label>
                <input
                  value={settings.bankIban}
                  onChange={e => setSettings(s => ({ ...s, bankIban: e.target.value }))}
                  placeholder="e.g. PK36 HABB..."
                  required
                />
              </div>
              <div className="form-group">
                <label>SWIFT BIC Code</label>
                <input
                  value={settings.bankSwift}
                  onChange={e => setSettings(s => ({ ...s, bankSwift: e.target.value }))}
                  placeholder="e.g. HABBPKKAAXXX"
                />
              </div>
            </div>

              <button type="submit" className="btn btn-primary" style={{ marginTop: 12 }}>Save Settings Changes</button>
            </form>

            <form className="card admin-form" onSubmit={handleChangePassword} style={{ maxWidth: 850, marginTop: 24 }}>
              <h3>Change Admin Password</h3>
              <div style={{ display: 'grid', gap: 16, maxWidth: 480 }}>
              <div className="form-group">
                <label>Current Password</label>
                <input
                  type="password"
                  value={pwForm.currentPassword}
                  onChange={e => setPwForm(f => ({ ...f, currentPassword: e.target.value }))}
                  placeholder="Enter your current password"
                  required
                  autoComplete="current-password"
                />
              </div>
              <div className="form-group">
                <label>New Password</label>
                <input
                  type="password"
                  value={pwForm.newPassword}
                  onChange={e => setPwForm(f => ({ ...f, newPassword: e.target.value }))}
                  placeholder="Min. 8 characters"
                  required
                  autoComplete="new-password"
                />
              </div>
              <div className="form-group">
                <label>Confirm New Password</label>
                <input
                  type="password"
                  value={pwForm.confirmPassword}
                  onChange={e => setPwForm(f => ({ ...f, confirmPassword: e.target.value }))}
                  placeholder="Repeat new password"
                  required
                  autoComplete="new-password"
                />
              </div>
              {pwMessage && (
                <p style={{ fontWeight: 600, fontSize: '0.88rem', color: pwMessage.startsWith('✓') ? 'var(--teal-primary)' : 'var(--danger)', margin: 0 }}>
                  {pwMessage}
                </p>
              )}
              <button type="submit" className="btn btn-secondary" style={{ maxWidth: 200 }}>Update Password</button>
              </div>
            </form>
          </>
        )}
      </main>
    </div>
  );
}

export default Admin;
